import Image from "next/image";
import React, { useState, useEffect, useContext } from "react";
import { weatherIcons } from "utils/weatherIcons";
import styles from "./OpenWeatherWidget.module.scss";
import {
  convertMetricToImperialTemp,
  convertImperialToMetricTemp,
} from "utils/helpers/units";

export default function OpenWeatherWidget({ location, style = "transparent" }) {
  const [weatherData, setWeatherData] = useState(null);
  const [temperatureUnit, setTemperatureUnit] = useState("metric"); // 'metric' for Celsius, 'imperial' for Fahrenheit
  const [currentTemperature, setCurrentTemperature] = useState(null);

  const lat = location?.latitude;
  const lon = location?.longitude;
  const CITY_NAME = location?.city;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `/api/external/open-weather-map?${
            CITY_NAME ? `q=${CITY_NAME}&` : ""
          }${
            lat && lon ? `lat=${lat}&lon=${lon}&` : ""
          }units=${temperatureUnit}`
        );

        if (!response.ok) {
          throw new Error("Failed to fetch weather data");
        }

        const data = await response.json();

        setWeatherData(data);
        setCurrentTemperature(data?.main?.temp);
      } catch (error) {
        // setWeatherData(null);
        console.error("Error fetching weather data:", error);
      }
    };

    fetchData();
  }, [CITY_NAME, lat, lon]); // Re-fetch when temperatureUnit changes

  const toggleCelsius = () => {
    setTemperatureUnit("metric");
    setCurrentTemperature(weatherData?.main?.temp);
  };

  const toggleFahrenheit = () => {
    const imperialTemp = convertMetricToImperialTemp(weatherData?.main?.temp);
    setCurrentTemperature(imperialTemp);

    setTemperatureUnit("imperial");
  };

  if (!weatherData) {
    return null;
  }

  return (
    <>
      {weatherData && (
        <div className={`${styles.container} ${styles[style]}`}>
          <div className={`${styles.description}`}>
            <span className={`${styles.location}`}>
              {weatherData.name}, {weatherData.sys.country}
            </span>
            <p className={`${styles.text}`}>
              {weatherData.weather[0].description}
            </p>
          </div>
          <div className={`${styles.icon}`}>
            <Image
              // src={`http://openweathermap.org/img/w/${weatherData.weather[0].icon}.png`}
              src={
                weatherIcons.find(
                  (icon) => icon.id === weatherData.weather[0].icon
                ).icon
              }
              alt={weatherData.weather[0].description}
              fill
            />
          </div>
          <div className={`${styles.temperature}`}>
            <span className={`${styles.number}`}>
              {Math.round(parseFloat(currentTemperature))}°{" "}
            </span>
            <div className={`${styles.toggleButtons}`}>
              <button
                onClick={toggleCelsius}
                className={`${styles.temperatureToggle}`}
              >
                <span
                  className={`${
                    temperatureUnit === "metric" ? styles.active : ""
                  }`}
                >
                  C
                </span>{" "}
              </button>
              <span className={`${styles.divider}`}>|</span>
              <button
                onClick={toggleFahrenheit}
                className={`${styles.temperatureToggle}`}
              >
                <span
                  className={`${
                    temperatureUnit === "imperial" ? styles.active : ""
                  }`}
                >
                  F
                </span>{" "}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
